import { render, staticRenderFns } from "./user_card.vue?vue&type=template&id=d962c358&scoped=true&"
import script from "./user_card.vue?vue&type=script&lang=js&"
export * from "./user_card.vue?vue&type=script&lang=js&"
import style0 from "./user_card.vue?vue&type=style&index=0&id=d962c358&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d962c358",
  null
  
)

export default component.exports